import { Link } from "react-router-dom";
import Button from "../../common/Button";
import classNames from "./About.module.css";

const About = () => {
  return (
    <div className={classNames.About}>
      <h1>About Langfinity</h1>
      <section>
        <h2 style={{ color: "var(--langfinity-orange)" }}>Who are we?</h2>
        <div>
          <h4>
            Langfinity is an innovative, AI-powered real-time translation
            technology that bridges language barriers and fosters global
            communication. 🌐
          </h4>
          <h4>
            Our mission is to connect people across the world, enabling them to
            express their ideas, opinions, and emotions confidently in their
            native languages. 🌍
          </h4>
          <h4>
            At Langfinity, we believe that language is more than just words—it's
            a core part of identity. 💡
          </h4>
          <h4>
            Our technology not only preserves the diversity of languages but
            also ensures that individuals feel empowered to let their authentic
            selves shine through in any global setting. 🌈
          </h4>
          <h4>
            By facilitating seamless multilingual communication, we are building
            a world where everyone can connect and collaborate, no matter where
            they are or what language they speak. 💫
          </h4>
        </div>
      </section>

      <section>
        <h2 style={{ color: "var(--langfinity-blue" }}>Our mission</h2>
        <div>
          <h4>
            Our mission is to empower people speaking different languages to
            build deeper trust and authentic connections, moving beyond
            surface-level understanding to create meaningful, human-centered
            multilingual communication.
          </h4>
        </div>
      </section>

      <section>
        <h2 style={{ color: "var(--langfinity-pink" }}>Our vision</h2>
        <div>
          <h4>
            Breaking down language barriers for all beings in the universe,
            enabling instant understanding and limitless communication across
            every corner of existence.
          </h4>
        </div>
      </section>

      <div className={classNames.Quote}>
        <h4>
          "If you talk to a man in a language he understands, that goes to his
          head. If you talk to him in his own language, that goes to his heart."
        </h4>

        <h4>— Nelson Mandela</h4>
      </div>

      <section>
        <h2 style={{ color: "var(--langfinity-orange)" }}>Our story</h2>
        <h4>
          🌎 Langfinity (prev. Byrdhouse AI) was inspired by one of the
          co-founders' experiences as a first-generation immigrant dealing with
          language barriers. In high school, she was laughed at and picked on
          for not speaking English fluently. During that time, she envisioned a
          world where people could instantaneously understand each other,
          regardless of the languages they speak. For 10 years, we have worked
          on multilingual teams with team members who struggle to understand and
          confidently express themselves in different languages.
        </h4>
        <h4>
          🛠️ From building technology products to help people with language
          barriers, we learned that it was painful to build deeper relationships
          and understanding in different languages. It's very expensive and
          time-consuming to find and hire interpreters - the conversation
          usually takes twice as long to finish, and the existing solutions are
          often not real-time, affordable or accurate. Our goal is to change
          that.
        </h4>
        <h4>
          🤟 We initially built Langfinity (prev. Byrdhouse AI) to solve our own
          problems, and it gradually grew to help more organizations and
          individuals.
        </h4>
      </section>

      <section>
        <h2 style={{ color: "var(--langfinity-blue" }}>
          Working at Langfinity
        </h2>
        <h4>
          At Langfinity, we champion customer obsession by delivering real-time,
          high-accuracy translation that removes barriers for people everywhere.
          We foster inclusion with support for all languages so every voice can
          be heard. Our drive for innovation fuels continuous improvements in
          speed, human-like accuracy, and domain-specific expertise. And our
          commitment to craftsmanship ensures every feature— from intuitive
          interfaces to natural voice translations—offers a seamless,
          human-centered experience.
        </h4>
        <h4>Ready to shape the future of global communication?</h4>
        <Link to="mailto:team@langfinity.ai" target="_blank">
          <Button
            size="landing"
            color="black"
            backgroundColor="transparent"
            borderColor="black"
          >
            Contact us
          </Button>
        </Link>
      </section>
    </div>
  );
};

export default About;
